<h2 mat-dialog-title class="dialog-title">
  <div class="title-row">
    <span class="type-badge" [ngClass]="'type-' + data.notification.type">
      <mat-icon>{{ getTypeIcon(data.notification.type) }}</mat-icon>
      {{ getTypeLabel(data.notification.type) }}
    </span>
    <span class="publish-date">{{ data.notification.publishedOn | date:'MMM d, y' }}</span>
  </div>
  <div class="notification-title">{{ data.notification.title }}</div>
</h2>

<mat-dialog-content>
  <div class="content-body" [innerHTML]="data.notification.content"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="acknowledge()">Acknowledge</button>
</mat-dialog-actions>
